export const __DEV__ = process.env.NODE_ENV === 'development'
export const NODE_ENV = process.env.NODE_ENV
export const RAYGUN_API_KEY = 'FKeNZ3yk3o1j3YhTHwN5pw=='
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID || ''
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || ''
